import { useLocalization } from '@components/Localization'
import { FilterMenuCheckbox, Box } from '@gassan-ui'
import { Item } from '@lib/kontent'
import { BrandPage } from '@lib/kontent/models/BrandPage'
import { StoreService } from '@lib/kontent/models/StoreService'
import React, { FC } from 'react'
import { FilterAction, FilterState } from '../reducer'

type Props = {
  dispatch: React.Dispatch<FilterAction>
  brands?: Item<BrandPage>[]
  services?: Item<StoreService>[]
  filters: FilterState
}

const FilterBar: FC<Props> = ({ dispatch, brands, services, filters }) => {
  const { lang, messages } = useLocalization()
  return (
    <Box alignItems="center" display={{ _: 'none', large: 'flex' }}>
      <FilterMenuCheckbox
        lang={lang}
        items={[
          {
            value: 'netherlands',
            label: messages.stores.netherlands
          },
          {
            value: 'singapore',
            label: 'Singapore'
          }
        ]}
        label={messages.stores.country}
        activeFilters={filters.country.length}
        value={filters.country}
        onSelectItem={value => {
          dispatch({ type: 'set-filter', key: 'country', value: value as string[] })
        }}
        onClickReset={() => dispatch({ type: 'reset-filter', key: 'country' })}
      ></FilterMenuCheckbox>
      <FilterMenuCheckbox
        lang={lang}
        items={[
          {
            value: 'opened-now',
            label: messages.stores.opendNow
          },
          {
            value: 'opened-evening',
            label: messages.stores.opendEvening
          },
          {
            value: 'opened-sunday',
            label: messages.stores.opendSunday
          }
        ]}
        label={messages.stores.openingHours}
        activeFilters={filters.opened.length}
        value={filters.opened}
        onSelectItem={value => {
          dispatch({ type: 'set-filter', key: 'opened', value: value as string[] })
        }}
        onClickReset={() => dispatch({ type: 'reset-filter', key: 'opened' })}
      ></FilterMenuCheckbox>
      <FilterMenuCheckbox
        lang={lang}
        items={services.map(service => ({
          value: service.system.codename,
          label: service.elements.title.value
        }))}
        label="Services"
        activeFilters={filters.services.length}
        value={filters.services}
        onSelectItem={value => {
          dispatch({ type: 'set-filter', key: 'services', value: value as string[] })
        }}
        onClickReset={() => dispatch({ type: 'reset-filter', key: 'services' })}
      ></FilterMenuCheckbox>
      <FilterMenuCheckbox
        hasSearch
        placeholder={lang === 'nl' ? 'Zoek merken' : 'Search brands'}
        noneFoundText={lang === 'nl' ? 'Geen merken gevonden' : 'No brands found'}
        label={lang === 'nl' ? 'Merken' : 'Brands'}
        activeFilters={filters.brands.length}
        items={brands.map(brand => ({
          value: brand.system.codename,
          label: brand.elements.title.value
        }))}
        value={filters.brands}
        onSelectItem={value =>
          dispatch({ type: 'set-filter', key: 'brands', value: value as string[] })
        }
        onClickReset={() => dispatch({ type: 'reset-filter', key: 'services' })}
      />
    </Box>
  )
}

export default FilterBar
